import { Pipe, PipeTransform } from '@angular/core';

import { format } from 'date-fns';

@Pipe({
    name: 'datefns',
})
export class DateFnsPipe implements PipeTransform {
    transform(value: Date | string, formatStr?: string) {
        if (!value) {
            return '';
        }

        if (!formatStr) {
            return value;
        }

        return format(value, formatStr);
    }
}



// WEBPACK FOOTER //
// ./src/pipes/datefns.pipe.ts